import { useMutation } from '@tanstack/react-query';

import { objectionResponsesTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const addObjectionResponse = (
  payload: objectionResponsesTypes.AddObjectionResponsePayload
) => {
  return axios.put('/ai/objection-responses', payload);
};

type QueryFnType = typeof addObjectionResponse;

type UseAddObjectionResponseOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useAddObjectionResponse = ({ config }: UseAddObjectionResponseOptions = {}) => {
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    ...restConfig,
    mutationFn: addObjectionResponse,
    onSuccess: (_data, variables, context) => {
      queryClient.invalidateQueries(['objection-responses', variables.aiId]);
      onSuccess?.(_data, variables, context);
    },
  });
};
